export default "__VITE_PUBLIC_ASSET__75cbe934__"